import { BrandConfig } from './types';

export const autoshopping: BrandConfig = {
	id: 'autoshopping',
	appName: 'Auto Shopping Itapoan',
	basePath: '',
	logoFile: 'logo.png',
	registerUrl: 'https://www.canaldorepasse.com.br/cadastro.aspx',
	contacts: {
		email: 'mkt.autoasi@gmail.com',
		phone: '+5571996070789',
		proneFormatted: '(71) 9 9607-0789',
		address: 'Rua XPTO, 0',
	},
	colors: {
		primaryLighter: 'rgba(219, 0, 0, 0.05)',
		primaryLight: '#ff4d4d',
		primaryMedium: '#db0000',
		accent: '#db0000',
		accentSoft: 'rgba(219, 0, 0, 0.08)',
		neutralBlack: '#000000',
		neutralYellow: '#ffff00',
		muiPrimaryMain: '#db0000',
		muiPrimaryLight: '#ff4d4d',
		muiPrimaryDark: '#a00000',
		muiSecondary: {
			main: '#ffff00',
			light: '#ffff55',
			dark: '#cccc00',
		},
	},
	api: {
		baseApiUrl: {
			dev: 'https://homologacao.canaldorepasse.com.br/webservice/api',
			prod: 'https://homologacao.canaldorepasse.com.br/webservice/api',
		},
		externalBackofficeApiUrl: {
			dev: 'https://www.canaldorepasse.com.br/backoffice',
			prod: 'https://www.canaldorepasse.com.br/backoffice',
		},
		imagesBaseUrl: {
			anuncios: 'https://canaldorepasse.com.br/anuncios/fotos',
			grupoConcessionaria: 'https://canaldorepasse.com.br/cadastros/fotos/grupo_concessionaria',
			concessionaria: 'https://canaldorepasse.com.br/cadastros/fotos/concessionaria',
		},
	},
	auth: {
		tokenFormat: 'formdata',
	},
};
